import PropTypes from 'prop-types';

import Menu from '#globalComponents/Overlay/Menu';
import Popover from '#globalComponents/Overlay/Popover';

const ReassignPopover = ({ members, currentUserId, onSelect, onClose, onRemove, anchorRef }) => (
	<Popover open onClose={onClose} anchorRef={anchorRef} size="s" align="end">
		<Menu>
			<Menu.Label>Zuweisen an</Menu.Label>
			{members.map((m) => (
				<Menu.Item key={m.userId} onClick={() => onSelect(m.userId)} selected={m.userId === currentUserId}>
					{m.fullName ?? m.email}
				</Menu.Item>
			))}
			{currentUserId && onRemove && (
				<>
					<Menu.Separator />
					<Menu.Item onClick={onRemove}>Zuweisung entfernen</Menu.Item>
				</>
			)}
		</Menu>
	</Popover>
);

ReassignPopover.propTypes = {
	members: PropTypes.array.isRequired,
	currentUserId: PropTypes.string,
	onSelect: PropTypes.func.isRequired,
	onClose: PropTypes.func.isRequired,
	onRemove: PropTypes.func,
	anchorRef: PropTypes.shape({ current: PropTypes.any }),
};

export default ReassignPopover;
